'use client';

import Link from 'next/link';
import { Home, Hammer, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';

export default function NotFound() {
  return (
    <html lang="en-AU">
      <body className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <Card className="border-muted-foreground/20">
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-primary/10">
                <Hammer className="h-10 w-10 text-primary" />
              </div>
              <CardTitle className="text-2xl">Page not found</CardTitle>
              <CardDescription className="mt-2">
                Sorry, we couldn't find the page you're looking for.
              </CardDescription>
            </CardHeader>
            
            <CardContent className="space-y-4">
              <div className="rounded-lg bg-accent/50 p-4">
                <p className="text-sm text-accent-foreground">
                  The link you followed may be broken, or the page may have been moved.
                </p>
              </div>
              
              <div className="rounded-lg bg-muted p-4">
                <p className="text-sm text-muted-foreground">
                  <strong>Looking to hire construction workers?</strong><br />
                  Head to your dashboard to post a job or browse available workers.
                </p>
              </div>
            </CardContent>
            
            <CardFooter className="flex flex-col gap-3">
              <Button asChild className="w-full">
                <Link href="/">
                  <Home className="mr-2 h-4 w-4" />
                  Go to homepage
                </Link>
              </Button>
              
              <Button 
                onClick={() => window.history.back()} 
                className="w-full"
                variant="outline"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Go back
              </Button>
            </CardFooter>
          </Card>
          
          <footer className="mt-6 text-center">
            <p className="text-xs text-muted-foreground">
              RateRight — Hire Construction Workers Fast
            </p>
          </footer>
        </div>
      </body>
    </html>
  );
}